import React from 'react';

import { default as Video}  from 'react-youtube';

interface YouTubeVideoProps {
  videoUrl: string;
  onEnd?: () => void;
}

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({ videoUrl, onEnd }) => {
  const n = videoUrl.lastIndexOf('/');
  const videoId = videoUrl.substring(n + 1);

  return (
    <Video
      videoId={videoId}
      onEnd={() => onEnd && onEnd()}
      opts={{
        width: '680',
        height: '385',
        playerVars: {
          controls: 0,
        }
      }} />
  );
};

export default YouTubeVideo;
